import {
  USER_NO,
  USER_NAME,
  LEVEL_CODE,
  IS_AUTH, ACCESS_TOKEN
} from "./mutation_types";

import loginApi from "../service";
import session from "@/kuaa/kuaa-sessions";

let setUserNo = ({ commit }, data) => {
  commit(USER_NO, data);
};

let setAdminName = ({ commit }, data) => {
  commit(USER_NAME, data);
};

let setLevelCode = ({ commit }, data) => {
  commit(LEVEL_CODE, data);
};

let setIsAuth = ({ commit }, data) => {
  commit(IS_AUTH, data);
};

let setAccessToken = ({ commit }, data) => {
  commit(ACCESS_TOKEN, data);
};

let setLoginInfo = ({ commit }, data) => {
  commit(LOGIN_INFO, data);
};

export default {
  async login(store, { userNo, userPasswd }) {
    
    try {
      const res = await loginApi.login(userNo, userPasswd);

      if (res.data.success) {
        session.set('userNo',res.data.data.userNo);
        session.set('token',res.data.data.token);
        session.set('group',res.data.data.userRight);
        // 비밀번호를 변경 해야 하는지 여부
        session.set('pwdChgYn',!res.data.data.changePwdDate? 'Y': 'N');  // pwdChangeDayCnt 유효기간 체크시 추가 할 것
        setIsAuth(store, true);
        setAccessToken(store, res.data.data.token);
        //setLoginInfo(store, res.data.data);
        //commit(LOGIN_INFO, res.data.data);
        //commit("setLoginInfo", res.data.data);
      } else {
        setIsAuth(store, false);
        setAccessToken(store, null);
      }
      //return store.getters.getIsAuth;
      return res.data;
      
    }catch(e){
//      console.log(e);
      alert(e);
      setIsAuth(store, false);
      setAccessToken(store, null);
      this.$router.push({ path: "/login" });
    }
  },
};
